var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.189 43.3099H36.939C38.429 43.3099 40.779 44.2599 41.689 45.6799H46.439C48.659 45.6799 51.189 47.7599 51.189 50.4299H55.939C58.159 50.4299 60.689 52.5099 60.689 55.1799V76.5299C60.689 81.3299 55.939 85.2 55.939 88.39V90.7599",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.189 55.16V26.7C32.189 24.08 30.069 21.95 27.439 21.95C24.819 21.95 22.689 24.08 22.689 26.7V59.91L19.519 62.95L13.3188 53.34C9.52885 48.11 3.70898 51.05 3.70898 53.34C3.70898 53.34 10.899 73.9299 11.939 75.5499C13.599 78.1399 20.3091 83.97 20.3091 86.01V90.76",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6792 45.6799V55.1599",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1689 50.4199V57.5399",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41895 44.7199V40.8199",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41895 32.79V16.46C7.41895 10.74 12.0588 6.09998 17.7788 6.09998H83.0391C88.7591 6.09998 93.3989 10.74 93.3989 16.46V65.83C93.3989 71.55 88.7591 76.19 83.0391 76.19H74.0889",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0791 76.2H66.1792",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6992 33.71C19.8692 33.42 17.6489 31.02 17.6489 28.11V20.96C17.6489 17.87 20.179 15.34 23.269 15.34H30.4189C33.5089 15.34 36.0391 17.87 36.0391 20.96V28.11C36.0391 30.59 34.419 32.7 32.189 33.44",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0391 15.35C56.1191 15.35 60.229 19.47 60.229 24.54V24.55C60.229 29.63 56.1091 33.74 51.0391 33.74H51.0288C45.9488 33.74 41.8389 29.62 41.8389 24.55V24.54C41.8389 19.47 45.9591 15.35 51.0391 15.35Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2393 15.35C80.3193 15.35 84.4292 19.47 84.4292 24.54V24.55C84.4292 29.63 80.3093 33.74 75.2393 33.74H75.229C70.149 33.74 66.0391 29.62 66.0391 24.55V24.54C66.0391 19.47 70.1493 15.35 75.2393 15.35Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign);
export default __webpack_public_path__ + "static/media/design.aab8e83f86ebd44fb3f434d449b2ad43.svg";
export { ForwardRef as ReactComponent };